import globalevents_controller from '../globalevents/globalevents_controller'
import { Utility } from '../utility/utility_controller'

var breakpoints_controller = {
	i: function () {
		if (layData.phone_layout_active == 'on') {
			window.laytheme.on('newpageshown', setData)
			bindResize()
		}
	},
}

var Breakpoints = {
	mainHasCustomPhoneGrid: false,
	footerHasCustomPhoneGrid: false,
}

export { breakpoints_controller, Breakpoints }

var setData = function () {
	Breakpoints.mainHasCustomPhoneGrid = jQuery('#custom-phone-grid').length == 1 ? true : false
	Breakpoints.footerHasCustomPhoneGrid = jQuery('#footer-custom-phone-grid').length == 1 ? true : false
}

var bindResize = function () {
	var lastSize = Utility.screenSize

	jQuery(window).on('window_width_changed orientationchange', function () {
		// rerender layouts if phone layout exists and we just switched between desktop/phone
		if (((Utility.screenSize == 'phone' && lastSize == 'tablet') || (Utility.screenSize == 'phone' && lastSize == 'desktop')) && (Breakpoints.mainHasCustomPhoneGrid != false || Breakpoints.footerHasCustomPhoneGrid != false)) {
			globalevents_controller.triggerSwitchedDesktopLayoutToCustomPhoneLayout()
		} else if (((Utility.screenSize == 'tablet' && lastSize == 'phone') || (Utility.screenSize == 'desktop' && lastSize == 'phone')) && (Breakpoints.mainHasCustomPhoneGrid != false || Breakpoints.footerHasCustomPhoneGrid != false)) {
			globalevents_controller.triggerSwitchedCustomPhoneLayoutToDesktopLayout()
		}
		lastSize = Utility.screenSize
	})
}
